var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page && _vm.page.partials && _vm.page.partials.length)?_c('div',{staticClass:"page"},[_c('PartialsLoader',{attrs:{"partials":_vm.page.partials}}),_c('Footer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }